import { createSlice } from '@reduxjs/toolkit'

import storage from '@/utils/storage'
import { AuthorisationStates } from '@/constants'
import { AuthenticationState } from '@/shared/types/authentication'

const initialState: AuthenticationState = {
    authorisationFlow: AuthorisationStates.IDLE,
    authenticationState: '',
    information: {
        userId: undefined,
        roles: [],
        accessToken: undefined,
        idToken: undefined
    }
}

const getInitialState = () => {
    const userInformation = storage.getUserInformation()

    const mappedInitialState = { ...initialState }

    if (userInformation)
        mappedInitialState.information = { ...userInformation }

    return mappedInitialState
}

export const authenticationSlice = createSlice({
    name: 'authentication',
    initialState: getInitialState(),
    reducers: {
        updateAuthenticationInformation: (state, action) => {
            state.information = { ...action.payload }

            storage.setUserInformation(state.information)
        },
        updateAuthorisationFlow: (state, action) => {
            state.authorisationFlow = action.payload
        },
        updateAuthenticationState: (state, action) => {
            state.authenticationState = action.payload
        },
        resetAuthenticationState: (state) => {
            Object.assign(state, initialState)
            storage.clearUserInformation()
        }
    },
})

export const { updateAuthenticationInformation, updateAuthenticationState, resetAuthenticationState, updateAuthorisationFlow } =
    authenticationSlice.actions
export default authenticationSlice.reducer
